import type { IElement, PageElementOptions } from '@gohighlevel/ghl-proposals-common'
import { computed } from 'vue'

const DEFAULT_MARGIN = 48

/**
 * Content area offset for the document viewer. Fillable fields (and other
 * floating elements) store position relative to the content area (inside
 * header/footer and margins). When rendering with absolute position relative
 * to the page, we must add this offset so they appear in the correct place.
 */
export function useContentAreaOffset(page: IElement<PageElementOptions> | undefined) {
  return computed(() => {
    if (!page?.component?.options?.pageDimensions) {
      return { top: DEFAULT_MARGIN, left: DEFAULT_MARGIN }
    }
    const opts = page.component.options
    const margins = opts.pageDimensions.margins ?? {
      top: DEFAULT_MARGIN,
      right: DEFAULT_MARGIN,
      bottom: DEFAULT_MARGIN,
      left: DEFAULT_MARGIN,
    }
    const top = opts.headerHeight ?? margins.top ?? DEFAULT_MARGIN
    const left = margins.left ?? DEFAULT_MARGIN
    return { top, left }
  })
}
